import validate from "/usr/src/app/content/n3-promos-391a3918-f973-4917-814d-848342dcb970/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-391a3918-f973-4917-814d-848342dcb970/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}